import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-chat1-icon',
  templateUrl: './communication-chat1.component.html'
})
export class CommunicationChat1Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
